module.exports = __webpack_public_path__ + "static/img/S03.e2ce661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S03.png
// module id = VQ9U
// module chunks = 7